import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken, getUserSettings} from '../../storage'
import {NotificationManager} from 'react-notifications';
import {Loader, validateGSTIN} from '../../utils/misc'
import {Glyphicon} from 'react-bootstrap'
import StateSelect from './stateselect'

export default class AddClient extends React.Component {

  constructor() {
    super()
    this.state = {client:{name:"", phone:"",
                          email:"", gstin:"",
                          pan:"", tin:"", vat:"",
                           website:"", is_sez:false,
                           additional_params: [],
                           address:"", country:"", state:"", city:"", pin:"", state_ui:{state_name:"", state_code:""},
                           same_as_biiling: true, notes:"",
                           shipping_address:"", shipping_country:"", shipping_state:"", shipping_city:"", shipping_pin:"", shipping_state_ui:{state_name:"", state_code:""},
                         },

                         loading:true}
    this.modifyItemState = this.modifyItemState.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleStateChange = this.handleStateChange.bind(this)
    this.handleShippingStateChage = this.handleShippingStateChage.bind(this)
    this.mapShippingAddress = this.mapShippingAddress.bind(this)
    this.sameAsBilling = this.sameAsBilling.bind(this)
    this.deleteClient = this.deleteClient.bind(this)
  }


  handleParamChange = ( k,v) => {

    let currentItem = this.state.client
    let existingParams = this.state.client.additional_params
    if(typeof existingParams !== "undefined" && existingParams !== null) {
        existingParams = existingParams.filter(param => {
          return param.key !==k
        })
    }
    else {
      existingParams = []
    }

    existingParams.push({key:k, value:v})

    currentItem['additional_params'] = existingParams
    this.setState({client:currentItem})

  }

  deleteClient() {

    let confirmation = window.confirm('You are about to delete this client !')

    if(confirmation) {
      axios({
        url: '/delete_client/',
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.client
      }).then((response)=> {
        if(response.status === 200) {
            NotificationManager.success("Deleted client successfully")
          setTimeout(()=>{
            if(this.state.mode === "edit") {
              this.props.history.goBack()
            }
            else {
                this.props.history.push("/clients/")
            }
          }, 700)
        }
      }).catch((err)=> {
        if(typeof err.response !== "undefined" && err.response.data !== "undefined") {
          this.setState({deleteError: err.response.data.msg})
          NotificationManager.error(err.response.data.msg)
        }

      })
    }


  }

  componentDidMount() {


    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.client_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Client " + this.props.match.params.client_id
      this.getClient(this.props.match.params.client_id).then((response)=>{
        if(response.status===200) {
          let client = response.data.client
          client['state_ui'] = {state_name: client.state, state_code:client.state_code}
          client['shipping_state_ui'] = {state_name: client.shipping_state, state_code:client.shipping_state_code}
          this.setState({client: client, loading:false, total_invoices_amount:response.data.total_invoices_amount,
            total_cn_amount: response.data.total_cn_amount,
            total_receipts_amount: response.data.total_receipts_amount
            })

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Create Client "
        this.setState({loading:false})
    }

  }

  sameAsBilling(event) {
    const name = event.target.name;
    const value = event.target.checked
    this.modifyItemState(name, value)

    if(value) {
      this.mapShippingAddress()
    }
  }

  mapShippingAddress() {
    let client = this.state.client
    this.modifyItemState('shipping_address', client.address)
    this.modifyItemState('shipping_country', client.country)
    this.modifyItemState('shipping_state', client.state)
    this.modifyItemState('shipping_state_code', client.state_code)
    this.modifyItemState('shipping_city', client.city)
    this.modifyItemState('shipping_pin', client.pin)
    this.modifyItemState('shipping_state_ui': {state_name:client.state, state_code:client.state_code})
  }


  modifyItemState(key, value) {
        let currentItem = this.state.client
        currentItem[key] = value
        this.setState({
          client: currentItem
       });
  }

  handleStateChange(option) {

    this.modifyItemState('state', option.state_name)
    this.modifyItemState('state_code', option.state_code)
    this.modifyItemState('state_ui', option)

  }
  handleShippingStateChage(option) {

    this.modifyItemState('shipping_state', option.state_name)
    this.modifyItemState('shipping_state_code', option.state_code)
    this.modifyItemState('shipping_state_ui', option)

  }



  getClient(client_id) {
    return axios({
      url: '/get_client/?id='+client_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }


  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
   this.modifyItemState(name, value)
  }


  handleSubmit(event) {
    event.preventDefault()
    this.setState({submitting:true})
    let apiurl
    if(typeof this.state.mode !== "undefined" && this.state.mode === "edit"){
      apiurl = '/update_client/'
    }
    else {
      apiurl = '/create_new_client/'
    }
    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.client
    }).then((response)=> {
      this.setState({submitting:false})
      if(response.status === 200) {
        //this.props.dispatch(addingItemSuccess(response.data.item))
        if(typeof this.props.noredirect !== "undefined") {
          // if somebody says no redirect, then dont.
        }
        else if(typeof this.props.onAddCallback !== "undefined") {
          this.props.onAddCallback(response.data.client)
        }
        else {
          if(this.state.mode ==="edit") {
              NotificationManager.success("Updated client successfully")
          }
          else {
              NotificationManager.success("Created client successfully")
          }

        this.props.history.goBack()
        }
      }
    }).catch((err)=> {
      this.setState({submitting:false})
      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        let error_response_data = err.response.data.error
        if(typeof error_response_data !== "undefined") {
          NotificationManager.error(error_response_data)
        }
      }
    })

  }




  render() {


    let submitButton = <input type="submit" className="btn btn-success" value="save" onClick={this.handleSubmit}/>
    if(this.state.submitting) {
      submitButton = <input type="submit" className="btn btn-success" value="saving.." disabled />
    }


    let client = {}
    let validGstin, gstinFieldClass, gstinInvalidMsg
    if(typeof this.state.client !== "undefined" && this.state.client !== null) {
      client = this.state.client
     if(client.gstin) {
       validGstin  = validateGSTIN(client.gstin);
     }

    }

    if(client.gstin  && client.gstin.length>0 ) {
      if(validGstin) {
          validGstin =  <Glyphicon glyph="ok-circle" className="text-success" />
      }
      else {
          gstinInvalidMsg = "Invalid GSTIN"
          gstinFieldClass = "has-error"
      }
    }

    let settings = getUserSettings()
    let client_additional_params
    if(settings && settings.options) {

        if(settings.options.client_additional_params && settings.options.client_additional_params.length)  {
          client_additional_params = settings.options.client_additional_params.map((param, id)=>{

            let defaultValue
            if(client.additional_params) {
               client.additional_params.forEach((p)=>{

                if(p.key == param) {
                  defaultValue = p.value
                }
              })
            }

            return <div className="form-group" key={id}>
                  <label className="col-sm-3">
                    {param}
                  </label>
                  <div className="col-sm-9">
                      <input ref={param} type="text" defaultValue={defaultValue} className="form-control input-sm" onChange={(e)=>{
                          e.preventDefault();
                          this.handleParamChange(param, this.refs[param].value)
                        }} />
                  </div>

            </div>
          })
        }

    }




    let form
    if(this.state.loading) {
      return  <Loader />
    }
    else {

      const leftForm = (
        <div >
            <div className="form-group">
        <label className="col-sm-3">
          Name <span>*</span>
        </label>
        <div className="col-sm-9">
            <input name="name" type="text" value={client.name} className="form-control input-sm" onChange={this.handleInputChange} required />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          Phone
        </label>
        <div className="col-sm-9">
            <input name="phone" value={client.phone} type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          Email
        </label>
        <div className="col-sm-9">
            <input name="email" type="email" value={client.email} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className={"form-group " + gstinFieldClass}>
        <label className="col-sm-3">
          GSTIN {validGstin}
        </label>
        <div className="col-sm-9">
            <input name="gstin" type="text" value={client.gstin} className={"form-control input-sm "} onChange={this.handleInputChange}  />
            <span className="text-danger small">{gstinInvalidMsg}</span>
        </div>
            </div>


            <div className="form-group">
        <label className="col-sm-3">
          PAN
        </label>
        <div className="col-sm-9">
            <input name="pan" type="text" value={client.pan} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          TIN
        </label>
        <div className="col-sm-9">
            <input name="tin" type="text" value={client.tin} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          VAT
        </label>
        <div className="col-sm-9">
            <input name="vat" type="text" value={client.vat} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className="form-group">
        <label className="col-sm-3">
          Website
        </label>
        <div className="col-sm-9">
            <input name="website" type="text" value={client.website} className="form-control input-sm" onChange={this.handleInputChange}  />
        </div>
            </div>

            <div className="form-group">
              <label className="col-sm-3">
                Is SEZ
              </label>
              <div className="col-sm-9">
                <input name="is_sez" type="checkbox" checked={client.is_sez} onChange={this.handleInputChange}  />
              </div>
            </div>



        </div>
      )
      let shippingform


      if(!this.state.loading && !client.same_as_biiling) {


       shippingform = (<div>

        <div className="form-group">
          <label className="col-sm-3">
            Address
          </label>
          <div className="col-sm-9">
            <input name="shipping_address" value={client.shipping_address} type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            City
          </label>
          <div className="col-sm-9">
            <input name="shipping_city" value={client.shipping_city} type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            State
          </label>
          <div className="col-sm-9">
            <StateSelect value={client.shipping_state_ui} name="shipping_state" handleChange={this.handleShippingStateChage} />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            Country
          </label>
          <div className="col-sm-9">
            <input name="shipping_country" value={client.shipping_country} type="text" className="form-control input-sm" onChange={this.handleInputChange} />
          </div>
        </div>





        <div className="form-group">
          <label className="col-sm-3">
            Pin
          </label>
          <div className="col-sm-9">
            <input name="shipping_pin" value={client.shipping_pin} type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        </div>)

      }

      const rightForm = (<div>
        <div className="form-group">
          <label className="col-sm-3">
            Address
          </label>
          <div className="col-sm-9">
            <input name="address" type="text" value={client.address} className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            City
          </label>
          <div className="col-sm-9">
            <input name="city" type="text" value={client.city} className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            State
          </label>
          <div className="col-sm-9">
            <StateSelect value={client.state_ui} name="state" handleChange={this.handleStateChange} />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3">
            Country
          </label>
          <div className="col-sm-9">
            <input name="country" type="text" value={client.country} className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>


        <div className="form-group">
          <label className="col-sm-3">
            Pin
          </label>
          <div className="col-sm-9">
            <input name="pin" type="text" value={client.pin} className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-9">
            <strong>Shipping Address</strong>
          </label>
        </div>

        <div className="form-group">
          <label className="col-sm-9">
              <input type="checkbox" name="same_as_biiling" checked={client.same_as_biiling} onChange={this.sameAsBilling} /> Same as billing address ?
          </label>
        </div>



        {shippingform}

      </div>)

      const notes = (
        <div className="form-group">
          <label className="col-sm-3">
            Notes
          </label>
          <div className="col-sm-9">
            <textarea name="notes" className="form-control" rows="3" value={client.notes} onChange={this.handleInputChange}></textarea>
          </div>
        </div>
        )

    form = (
        <div className="">
          <form className="form-horizontal" >
            <div className="form-group">
              <div className="col-md-6">
                  {leftForm}
                  {notes}
              </div>
              <div className="col-md-6">
                  {rightForm}
                  {client_additional_params}
              </div>
            </div>
            </form>
            <div className="form-action-group text-right">
              {submitButton}
            </div>
          </div>
        )


        let pageHeader, deleteClientBtn, deleteError, pps
        if(this.state.mode === "edit") {
          deleteClientBtn = <button className="btn btn-danger" onClick={this.deleteClient}>Delete Client</button>

            pageHeader = <div className="row">
                <div className="col-sm-10">
                    <h3>{"Edit Client: " + client.name}</h3>
                </div>
                <div className="col-sm-2 text-right">
                  {deleteClientBtn}
                  {deleteError}
                </div>
            </div>

            pps = <div className="row">
                <div className="col-sm-3">
                  <div className="panel panel-info">
                    <div className="panel-body text-center">
                      <div className="text-muted"><strong>Total Invoice Amount</strong></div>
                      <div> <h4>₹ {parseFloat(this.state.total_invoices_amount).toFixed(2)}</h4> </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="panel panel-info">
                    <div className="panel-body text-center">
                      <div className="text-muted"> <strong>Total Receipt Amount</strong></div>
                      <div> <h4>₹ {parseFloat(this.state.total_receipts_amount).toFixed(2)}</h4> </div>
                    </div>
                  </div>

                </div>
                <div className="col-sm-3">
                  <div className="panel panel-info">
                    <div className="panel-body text-center">
                      <div className="text-muted"> <strong>Total CreditNote Amount</strong></div>
                      <div> <h4>₹ {parseFloat(this.state.total_cn_amount).toFixed(2)}</h4> </div>
                    </div>
                  </div>

                </div>
                <div className="col-sm-3">
                  <div className="panel panel-info">
                    <div className="panel-body text-center">
                      <div className="text-muted"> <strong>Net Due</strong></div>
                      <div> <h4>₹ { parseFloat(client.balance_amount).toFixed(2)}</h4> </div>
                    </div>
                  </div>

                </div>
            </div>
        }
        else {
          pageHeader =  <h3 >Create New Client</h3>
        }


        return <div>
          <section className="medium">
              {pageHeader}
          </section>
          <section className="small">
            {pps}
          </section>

          <div className="row">
            <div className="col-xs-12">
              {form}
            </div>
          </div>


        </div>
    }


  }
}



// WEBPACK FOOTER //
// ./src/components/client/addclientnew.js